// src/pages/KycBisPage.jsx
// TEMPORARY layout playground: /kyc-bis-2/:id renders ONLY the PEP exposure card
// using the experimental KycSectionPepBis2 layout (overview tiles extending into
// aligned detail cards). Edits stay in local state — nothing is saved.
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import KycSectionPepBis2 from "../kyc/sections/common/KycSectionPepBis2";
import "./css/KycFormPage.css";

export default function KycBisPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "kyc", id));
        if (cancelled) return;
        if (!snap.exists()) {
          setError("KYC record not found.");
          return;
        }
        setForm(snap.data());
      } catch (e) {
        if (!cancelled) setError(e?.message || "Failed to load the KYC record.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  function setAt(path, value) {
    setForm((prev) => {
      const next = structuredClone(prev || {});
      let ref = next;
      for (let i = 0; i < path.length - 1; i++) {
        const k = path[i];
        if (ref[k] == null || typeof ref[k] !== "object") ref[k] = {};
        ref = ref[k];
      }
      ref[path[path.length - 1]] = value;
      return next;
    });
  }

  return (
    // kycFormPage class is required: the section card's design (.kycCard,
    // .kycSectionHead, toggles, …) is scoped under it in KycFormPage.css.
    <div
      className="kycFormPage staffShellContentPage container-xxl"
      style={{ padding: "24px 16px 60px" }}
    >
      <div
        className="d-flex align-items-center justify-content-between flex-wrap gap-2"
        style={{ marginBottom: 16 }}
      >
        <div>
          <h5 className="mb-1">PEP exposure — layout experiment 2 (classic arrows)</h5>
          <div className="small text-muted">
            Temporary alternative layout. Changes on this page are{" "}
            <strong>not saved</strong>. Client: {form?.customer?.name || id}
          </div>
        </div>
        <Link to={`/kyc/${id}`} className="btn btn-sm btn-outline-secondary">
          Open the real /kyc form
        </Link>
      </div>

      {error ? (
        <div className="alert alert-warning">{error}</div>
      ) : !form ? (
        <div className="text-muted small">Loading…</div>
      ) : (
        <section id="kyc-sec-pep-bis2">
          <KycSectionPepBis2
            form={form}
            onSetAt={setAt}
            sectionNo={5}
            initiallyExpanded
          />
        </section>
      )}
    </div>
  );
}
